<script setup>
import { computed } from "vue";

const props = defineProps({ status: Number, message: String });

const title = computed(() => {
    return {
        503: "Servicio no disponible",
        500: "Error de servidor",
        404: "Página no encontrada",
        403: "Acceso Prohibido",
    }[props.status];
});

const description = computed(() => {
    return props.message
        ? props.message
        : {
              503: "Perdon, estamos realizando mantenimiento",
              500: "Lo sentimos, algo salió mal en nuestros servidores.",
              404: "Lo sentimos, la página que está buscando no se pudo encontrar.",
              403: "Lo sentimos, no tiene permiso para acceder a esta página.",
          }[props.status];
});
</script>

<template>
    <q-page padding class="flex flex-center bg-grey-10 text-white">
        <div class="col text-center items-center justify-items-center">
            <img src="@/assets/logo-white.svg" alt="Logo de GLTN"  style="height: 100px;"/>
            <div class="q-mb-lg q-mt-xl text-h1">{{ title }}</div>
            <div class="text-h3">{{ description }}</div>
        </div>
    </q-page>
</template>
